export default __webpack_public_path__ + "static/media/illugraphic.2362b31f.png";